module.exports = __webpack_public_path__ + "img/favicon.be186b65.png";